var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.scaleFactTemplate,{tag:"component",attrs:{"disabled":!_vm.isFieldAvailableForEdit(_vm.scope.row, 'scale.currentScalePart.fact'),"data":_vm.scope.row.scale},on:{"change":function($event){
var _obj;
return _vm.saveElementPropChange(_vm.scope.row, 'scale', ( _obj = {}, _obj['currentScalePart.fact'] = $event, _obj ))}}})}
var staticRenderFns = []

export { render, staticRenderFns }